document.addEventListener('DOMContentLoaded', function() {
  console.log('Zaaikalender script geladen!');
  
  // Huidige actieve maand bijhouden
  let currentActiveMonth = null;
  
  // Wacht tot filters geladen zijn
  setTimeout(() => {
    setupMaandHighlighting();
    checkForActiveMonth(); // Check direct bij load
  }, 500);
  
  // Setup ook na elke filter update/AJAX reload
  document.addEventListener('productGridUpdated', () => {
    console.log('Product grid updated - highlighting opnieuw toepassen');
    setupMaandHighlighting();
    
    // Check voor actieve maanden
    setTimeout(() => {
      checkForActiveMonth(); // Dit zoekt ALLE actieve maanden
    }, 100);
  });

  // Ook luisteren naar infinite scroll events
  document.addEventListener('infiniteScrollLoaded', () => {
    console.log('Infinite scroll loaded - highlighting toepassen op nieuwe producten');
    setTimeout(() => {
      checkForActiveMonth(); // Highlight ook nieuwe producten
    }, 200);
  });
});

function setupMaandHighlighting() {
  console.log('Setting up maand highlighting...');
  
  // Zoek alle filter opties voor "zaaien" (je gele maandknoppen)
  const maandFilters = document.querySelectorAll('.filter-option[data-filter-type="zaaien"]');
  console.log('Gevonden maand filters:', maandFilters.length);
  
  maandFilters.forEach(maandFilter => {
    // Remove oude listeners om dubbele listeners te voorkomen
    maandFilter.removeEventListener('click', handleMaandClick);
    maandFilter.addEventListener('click', handleMaandClick);
  });
}

function handleMaandClick(event) {
  const geselecteerdeMaand = this.dataset.filterValue.toLowerCase();
  console.log('Maand geklikt:', geselecteerdeMaand);
  
  // Sla actieve maand op
  currentActiveMonth = geselecteerdeMaand;
  checkForActiveMonth(); // DEZE REGEL TOEGEVOEGD
  
  // Wacht even tot de filter verwerkt is, dan highlight toepassen
  setTimeout(() => {
    highlightMaandInCards(geselecteerdeMaand);
  }, 100);
  
  // Extra highlight na wat meer tijd (voor AJAX)
  setTimeout(() => {
    highlightMaandInCards(geselecteerdeMaand);
  }, 1000);
}

function checkForActiveMonth() {
  console.log('=== DEBUG checkForActiveMonth ===');
  
  // Zoek ALLE actieve maandfilters
  const activeFilters = document.querySelectorAll('.filter-option[data-filter-type="zaaien"].active');
  console.log('Actieve filters gevonden:', activeFilters.length);
  
  activeFilters.forEach((filter, index) => {
    console.log(`Filter ${index + 1}:`, filter.dataset.filterValue, filter);
  });
  
  // Reset ALLE highlights eerst
  const existingHighlights = document.querySelectorAll('.highlighted, .highlighted-inactive');
  console.log('Existing highlights om te resetten:', existingHighlights.length);
  
  existingHighlights.forEach(el => {
    el.classList.remove('highlighted', 'highlighted-inactive');
  });
  
  if (activeFilters.length > 0) {
    console.log('Highlighting', activeFilters.length, 'actieve maanden...');
    
    // Highlight elke actieve maand ZONDER reset
    activeFilters.forEach((filter, index) => {
      const maandNaam = filter.dataset.filterValue.toLowerCase();
      console.log(`Highlighting maand ${index + 1}:`, maandNaam);
      highlightSingleMaand(maandNaam); // Gebruik nieuwe functie
    });
  } else {
    console.log('Geen actieve filters gevonden');
  }
  
  // Final check
  setTimeout(() => {
    const finalHighlights = document.querySelectorAll('.highlighted');
    console.log('Final highlights na vertraging:', finalHighlights.length);
  }, 500);
}

// Nieuwe functie die NIET reset
function highlightSingleMaand(maandNaam) {
  if (!maandNaam) return;
  
  const searchTerms = [
    maandNaam,
    capitalizeFirst(maandNaam)
  ];
  
  searchTerms.forEach(term => {
    const matchingElements = document.querySelectorAll(`[data-month="${term}"]`);
    console.log(`Matching elements voor ${term}:`, matchingElements.length);
    
    matchingElements.forEach(element => {
      if (element.classList.contains('actieve-maand')) {
        // Actieve maand = fel geel
        element.classList.add('highlighted');
        console.log('Element actief gehighlight:', element);
      } else if (element.classList.contains('inactieve-maand')) {
        // Inactieve maand = subtiel geel
        element.classList.add('highlighted-inactive');
        console.log('Element inactief gehighlight:', element);
      }
    });
  });
}

function highlightMaandInCards(maandNaam) {
  console.log('Highlighting maand in cards:', maandNaam);
  
  // Reset alle highlights
  document.querySelectorAll('.highlighted, .highlighted-inactive').forEach(el => {
    el.classList.remove('highlighted', 'highlighted-inactive');
  });
  
  // Als er geen maand is, stop hier
  if (!maandNaam) {
    currentActiveMonth = null;
    return;
  }
  
  // Zoek alle maandweergave elementen met de juiste data-month
  const searchTerms = [
    maandNaam,
    capitalizeFirst(maandNaam)
  ];
  
  searchTerms.forEach(term => {
    const matchingElements = document.querySelectorAll(`[data-month="${term}"]`);
    console.log(`Matching elements voor ${term}:`, matchingElements.length);
    
    matchingElements.forEach(element => {
      if (element.classList.contains('actieve-maand')) {
        // Actieve maand = fel geel
        element.classList.add('highlighted');
        console.log('Element actief gehighlight:', element);
      } else if (element.classList.contains('inactieve-maand')) {
        // Inactieve maand = subtiel geel
        element.classList.add('highlighted-inactive');
        console.log('Element inactief gehighlight:', element);
      }
    });
  });
}

function capitalizeFirst(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

// Extra: Check voor filter changes via MutationObserver
function observeFilterChanges() {
  const filterContainer = document.querySelector('.filter-options');
  if (!filterContainer) return;
  
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;
        if (target.classList.contains('filter-option') && 
            target.dataset.filterType === 'zaaien') {
          
          if (target.classList.contains('active')) {
            // Filter werd actief
            currentActiveMonth = target.dataset.filterValue.toLowerCase();
            setTimeout(() => highlightMaandInCards(currentActiveMonth), 100);
          } else {
            // Filter werd inactief
            if (currentActiveMonth === target.dataset.filterValue.toLowerCase()) {
              currentActiveMonth = null;
              highlightMaandInCards(null); // Remove all highlights
            }
          }
        }
      }
    });
  });
  
  observer.observe(filterContainer, {
    attributes: true,
    subtree: true,
    attributeFilter: ['class']
  });
}

// Start observer na load
setTimeout(observeFilterChanges, 1000);